import { render, staticRenderFns } from "./PageModal.vue?vue&type=template&id=4ad7ec22&scoped=true"
import script from "./PageModal.vue?vue&type=script&lang=js"
export * from "./PageModal.vue?vue&type=script&lang=js"
import style0 from "./PageModal.vue?vue&type=style&index=0&id=4ad7ec22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad7ec22",
  null
  
)

export default component.exports